import submitCommand from '../../../services/submitCommand';
import uuid from '../../../services/uuid';
import { CourseStep } from '../models/course';

export const createThirdPartyVideoStep = (
  courseId: string,
  stepName: string,
  stepDescription: string,
  order: number,
  videoUrl: string,
  thirdPartySite: 'YouTube' | 'Vimeo',
  initiatingUserId: string
): Promise<CourseStep> => {
  const taskId = uuid.generate();
  return submitCommand(
    courseId,
    {
      id: courseId,
      taskId: taskId,
      initiatingUserId: initiatingUserId,
      taskName: stepName,
      taskDescription: stepDescription,
      videoUrl: videoUrl,
      order: order,
      thirdPartySite: thirdPartySite,
    },
    'AddThirdPartyVideoTask',
    'ThirdPartyVideoTaskIsAddedToTasklist',
    'TaskListError'
  ).then(() => ({
    _id: { id: taskId },
    _type: 'ThirdPartyVideo',
    taskName: stepName,
    order,
  }));
};
